import { createContext, useEffect, useState, useContext } from "react";
import { UserContext } from "./userProvider";
import apiUser from "../apiUser";

export const UsuariosContext = createContext();

export const UsuariosProvider = ({ children }) => {
  const { signed, user, setAlert } = useContext(UserContext);
  const [loading, setLoading] = useState(false);
  const [usuarios, setUsuarios] = useState(null);
  const [usuarioEdit, setUsuarioEdit] = useState(null);

  const getUsuarios = async () => {
    setLoading(true);
    try {
      const response = await apiUser.get("/usuarios/all");
      const { success, dados, message } = response.data;
      if (success) {
        setUsuarios(dados);
      } else {
        setAlert({
          visible: true,
          title: "Atenção!",
          placeholder: message,
          confirm: false,
          type: "warning",
        });
      }
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  const createUsuario = async (data) => {
    try {
      const response = await apiUser.post("/usuarios/create", data);
      const { success, message, dados } = response.data;
      if (success) {
        setAlert({
          visible: true,
          title: "Sucesso!",
          placeholder: message,
          confirm: false,
          type: "success",
        });
        getUsuarios();
        return dados;
      } else {
        setAlert({
          visible: true,
          title: "Atenção!",
          placeholder: message,
          confirm: false,
          type: "warning",
        });
      }
    } catch (error) {
      console.log(error);
    }
  };

  const updateUsuario = async (data) => {
    try {
      const response = await apiUser.post("/usuarios/update", data);
      const { success, message, dados } = response.data;
      if (success) {
        setAlert({
          visible: true,
          title: "Sucesso!",
          placeholder: message,
          confirm: false,
          type: "success",
        });
        getUsuarios();
        return dados;
      } else {
        setAlert({
          visible: true,
          title: "Atenção!",
          placeholder: message,
          confirm: false,
          type: "warning",
        });
      }
    } catch (error) {
      console.log(error);
    }
  };

  const toggleStatusUsuario = async (id) => {
    try {
      const response = await apiUser.post("/usuarios/toggle-status", { id });
      const { success, message, dados } = response.data;
      if (success) {
        setAlert({
          visible: true,
          title: "Sucesso!",
          placeholder: message,
          confirm: false,
          type: "success",
        });
        getUsuarios();
        return dados;
      } else {
        setAlert({
          visible: true,
          title: "Atenção!",
          placeholder: message,
          confirm: false,
          type: "warning",
        });
        return false;
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    // Gerente (2) também gerencia usuários (ativar/desativar) desde 15/set.
    if (signed && (user?.nivel === '3' || user?.nivel === '2') && !usuarios) getUsuarios();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [signed, user?.nivel]);

  return (
    <UsuariosContext.Provider value={{
      usuarios,
      loading,
      setLoading,
      getUsuarios,
      createUsuario,
      updateUsuario,
      toggleStatusUsuario,
      usuarioEdit,
      setUsuarioEdit,
    }}>
      {children}
    </UsuariosContext.Provider>
  );
};
